// src/services/api.js

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  console.error("❌ NEXT_PUBLIC_API_BASE_URL is not defined in .env");
}


export const imagesAPI = {
  // UPLOAD
  uploadImage: async (file, offerId) => {
    try {
      // 🔥 CORRECTION: Utilise 'authToken' comme tes autres services
      const token = localStorage.getItem('authToken');
      
      if (!token) {
        throw new Error('Veuillez vous reconnecter - session expirée');
      }

      const formData = new FormData();
      formData.append('file', file);
      formData.append('offerId', offerId);

      console.log('📤 Envoi image avec authToken:', token.substring(0, 20) + '...');
      
      const response = await fetch(`${API_BASE_URL}/images`, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Erreur upload');
      }
      
      return data;
    } catch (error) {
      throw new Error(error.message || 'Erreur lors de l\'upload de l\'image');
    }
  },

  // DELETE
  deleteImage: async (imageUrl) => {
    try {
      // 🔥 CORRECTION: Utilise 'authToken' comme tes autres services
      const token = localStorage.getItem('authToken');
      
      if (!token) {
        throw new Error('Veuillez vous reconnecter - session expirée');
      }
      
      const response = await fetch(`${API_BASE_URL}/images?url=${encodeURIComponent(imageUrl)}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Erreur suppression');
      }
      
      return data;
    } catch (error) {
      throw new Error(error.message || 'Erreur lors de la suppression de l\'image');
    }
  }
};